import React from 'react';
import { FiInstagram, FiYoutube, FiMessageSquare } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const socials = [
    {
      name: 'Instagram',
      icon: FiInstagram,
      url: 'https://www.instagram.com/translationtable/'
    },
    {
      name: 'TikTok',
      icon: FiMessageSquare,
      label: 'TikTok',
      url: 'https://www.tiktok.com/@translationtable'
    },
    {
      name: 'YouTube',
      icon: FiYoutube,
      url: 'https://www.youtube.com/@TranslationTable'
    }
  ];

  return (
    <footer className="bg-black py-12 border-t border-white/10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <h4 className="text-white font-bold text-lg mb-4">Translation Table</h4>
            <p className="text-gray-500 text-sm leading-relaxed">
              Created after watching too many good relationships end over bad communication. 
              Every week, thousands of people use these translations to stop fighting and start understanding.
            </p>
          </div>
          
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-bold mb-2">Connect With Us</h4>
            <div className="flex gap-6">
              {socials.map((social) => (
                <a 
                  key={social.name}
                  href={social.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="group flex flex-col items-center gap-2 text-gray-500 hover:text-brand-yellow transition-colors"
                  title={social.name}
                >
                  <SafeIcon icon={social.icon} size={24} />
                  <span className="text-[10px] uppercase tracking-widest font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                    {social.label || social.name}
                  </span>
                </a>
              ))}
            </div>
            <a href="mailto:hello@translationtable.com" className="text-gray-500 hover:text-brand-yellow text-sm mt-2">
              hello@translationtable.com
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-600 text-xs">
          <p>© 2024 Translation Table. All rights reserved.</p>
          <p className="mt-2 text-gray-700">Digital products only—no physical book shipped.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;